'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { X } from 'lucide-react'

const STORAGE_KEY = 'bb_discount_banner_v1_dismissed'
export const BANNER_HEIGHT = 44

// Focused, single-CTA pages where the promo bar (which links to /pricing) would
// only pull attention away from the one action we want: the homepage hero and
// the paid-traffic ad landing page.
const HIDE_ON_PATHS = new Set(['/', '/get-started'])

export function DiscountBanner() {
  const [visible, setVisible] = useState(false)
  const pathname = usePathname()
  const hiddenOnLandingPage = HIDE_ON_PATHS.has(pathname)
  const effectiveVisible = visible && !hiddenOnLandingPage

  useEffect(() => {
    if (hiddenOnLandingPage) {
      return
    }

    const timeout = window.setTimeout(() => {
      try {
        setVisible(!window.localStorage.getItem(STORAGE_KEY))
      } catch {
        setVisible(false)
      }
    }, 0)
    return () => window.clearTimeout(timeout)
  }, [hiddenOnLandingPage])

  useEffect(() => {
    document.documentElement.style.setProperty('--bb-banner-h', effectiveVisible ? `${BANNER_HEIGHT}px` : '0px')
  }, [effectiveVisible])

  function dismiss() {
    setVisible(false)
    document.documentElement.style.setProperty('--bb-banner-h', '0px')
    try { localStorage.setItem(STORAGE_KEY, '1') } catch {}
  }

  if (!effectiveVisible) return null

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-3 px-4 text-sm"
      style={{ height: BANNER_HEIGHT, background: '#c2571a' }}
    >
      <span className="text-white font-medium">
        Get <strong>30% off your first month</strong> — use code{' '}
        <span className="inline-block rounded bg-white/20 px-1.5 py-0.5 font-mono text-[11px] font-bold tracking-wider">
          FIRST30
        </span>{' '}
        at checkout
      </span>
      <a
        href="/pricing?coupon=FIRST30"
        className="shrink-0 rounded-lg bg-white px-3 py-1.5 text-xs font-bold text-[#c2571a] transition-colors hover:bg-orange-50"
      >
        Claim offer →
      </a>
      <button
        type="button"
        onClick={dismiss}
        className="absolute right-4 text-white/60 transition-colors hover:text-white"
        aria-label="Dismiss offer banner"
      >
        <X size={14} strokeWidth={2} aria-hidden />
      </button>
    </div>
  )
}
